import React, { Suspense, useState, useContext, useEffect } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import '../src/Styles/style.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "react-datepicker/dist/react-datepicker.css";
import loadGif from './assets/uedu_load_gif.gif'
import { GlobalContext } from './context'
import GlobalProvider from './context'
import { encyptedData, decryptedData } from './views/Access'
import AppRoutes from './AppRoutes'
import './Responsive.css'
import 'react-modern-drawer/dist/index.css'
import useActivityHeartbeat from './services/useStudentActivityHeartbeat'
import useVersionCheck from './useVersionCheck'

const loading = (
  <div
    style={{
      width: '100vw',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    className="d-flex sk-double-bounce"
  >
    <div
      style={{
        marginTop: '-4%',
      }}
      className="d-flex flex-column"
    >
      <div className="d-flex justify-content-center">
        <img
          // width={400}
          // height={400}
          style={{ objectFit: 'contain', width: "30%" }}
          src={loadGif}
        />
      </div>
    </div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

// const AppRoutes = () => {
//   // const navigate = useNavigate()
//   const { state, dispatch } = useContext(GlobalContext)
//   const { isAuthenticated } = state
//   console.log(isAuthenticated, 'isAuthenticated')

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]))
//     } catch (e) {
//       return null
//     }
//   }

//   const fetchData = async () => {
//     const userData = await localStorage.getItem('USERDATA')
//     const userToken = await localStorage.getItem('USERTOKEN')

//     if (userData && userToken) {
//       const decryptuserData = decryptedData(userData)
//       const decryptuserToken = decryptedData(userToken)
//       const decodedJwt = parseJwt(decryptuserToken)
//       if (decodedJwt.exp * 1000 < Date.now()) {
//         dispatch({
//           type: 'LOGOUT',
//         })
//         toast.error('Session has been expired, Please login again')
//         Navigate('/login')
//       } else {
//         dispatch({
//           type: 'PROFILE',
//           payload: { ...decryptuserData, userToken: decryptuserToken },
//         })
//       }
//     } else {
//       dispatch({
//         type: 'LOGOUT',
//       })
//       Navigate('/login')
//     }
//   }

//   useEffect(() => {
//     fetchData()
//   }, [])

//   return (
//     <React.Fragment>
//       <ToastContainer />
//       <HashRouter>
//         <Suspense fallback={loading}>
//           {isAuthenticated ? (
//             <Routes>
//               <Route exact path="/login" name="Login Page" element={<Navigate to={'/'} />} />
//               <Route path="*" name="Home" element={<DefaultLayout />} />
//             </Routes>
//           ) : (
//             <Routes>
//               <Route exact path="/" name="Login" element={<Login />} />
//               <Route exact path="/login" name="Login Page" element={<Login />} />
//               {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
//               <Route exact path="/404" name="Page 404" element={<Page404 />} />
//               <Route exact path="/500" name="Page 500" element={<Page500 />} />
//               <Route exact path="*" name="Page 500" element={<Page404 />} />
//             </Routes>
//           )}
//         </Suspense>
//       </HashRouter>
//     </React.Fragment>
//   )
// }
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}

function App() {

  useActivityHeartbeat();
  useVersionCheck();
  
  return (
    <GlobalProvider>
      <AppRoutes />
    </GlobalProvider>
  )
}

export default App
